import { API_GET_RAYONS_BY_GOROD_ID, MAIN_URL, PORT } from "../../../constants/constants";
import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { getCityByObl, getGorod, getRayon } from "../../../utilities";

export const interestedIndividual = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-individual",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: false,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: false,
    },
    surname: {
      key: "surname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    name: {
      key: "name",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    midname: {
      key: "midname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    docType: {
      key: "docType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
    serialOfPassport: {
      key: "serialOfPassport",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[a-zA-Z]{2}$/,
        message: `Введите 2 латинские буквы`,
      },
    },
    numberOfPassport: {
      key: "numberOfPassport",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    docDateIssue: {
      key: "docDateIssue",
      label: "Дата выдачи",
      type: "date",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
          return "Дата не может быть ранее 26.09.1996";
        } else {
          return true;
        }
      },
    },
    docDepartment: {
      key: "docDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    persNum: {
      key: "persNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      upperCase: true,
    },
    stranId: {
      key: "stranId",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "РЕСПУБЛИКА БЕЛАРУСЬ",
    },
    oblId: {
      key: "oblId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    rayonId: {
      key: "rayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    gorodId: {
      key: "gorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    ulica: {
      key: "ulica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
      upperCase: true,
    },
    dom: {
      key: "dom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[^0].*$/,
        message: "Номер дома не может быть 0 или начинаться с 0",
      },
      upperCase: true,
    },
    korpus: {
      key: "korpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    kv: {
      key: "kv",
      label: "Квартира",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    phone: {
      key: "phone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Недопустимые символы: введите цифры, (), -, +`,
      },
    },
  },
};

export const interestedEntity = {
  caption: "Сведения о заинтересованном лице",
  gridKey: "grid-container-entity",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: false,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: false,
    },
    nameLe: {
      key: "nameLe",
      label: "Наименование юридического лица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    docDepartmentLe: {
      key: "docDepartmentLe",
      label: "Наименование гос. организации, осуществляющей регистрацию",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      upperCase: true,
    },
    egrNum: {
      key: "egrNum",
      label: "Единый  ЕГРЮЛиИП",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 9,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    unp: {
      key: "unp",
      label: "УНП",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 9,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      buttonDisabled: false,
    },
    stranId: {
      key: "stranId",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "РЕСПУБЛИКА БЕЛАРУСЬ",
    },
    oblId: {
      key: "oblId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    rayonId: {
      key: "rayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    gorodId: {
      key: "gorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    ulica: {
      key: "ulica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
      upperCase: true,
    },
    dom: {
      key: "dom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[^0].*$/,
        message: "Номер дома не может быть 0 или начинаться с 0",
      },
      upperCase: true,
    },
    korpus: {
      key: "korpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    kv: {
      key: "kv",
      label: "Квартира (офис)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    phone: {
      key: "phone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Недопустимые символы: введите цифры, (), -, +`,
      },
    },
  },
};

export const representPerson = {
  caption: "Сведения о представителе заинтересованного лица",
  gridKey: "grid-container-represent",
  blockVisibility: true,
  inputsOptions: {
    personalDataCaption: {
      key: "personalDataCaption",
      caption: "Личные данные",
      needInForm: false,
    },
    addressCaption: {
      key: "addressCaption",
      caption: "Адрес",
      needInForm: false,
    },
    agentSurname: {
      key: "agentSurname",
      label: "Фамилия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentName: {
      key: "agentName",
      label: "Имя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentMidname: {
      key: "agentMidname",
      label: "Отчество",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentDocType: {
      key: "agentDocType",
      label: "Документ",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    agentSerialOfPassport: {
      key: "agentSerialOfPassport",
      label: "Серия",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
      pattern: {
        value: /^[a-zA-Z]{2}$/,
        message: `Введите 2 латинские буквы`,
      },
    },
    agentNumberOfPassport: {
      key: "agentNumberOfPassport",
      label: "Номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      maxLength: 7,
      pattern: {
        value: /^[0-9]+[0-9]*$/,
        message: `Введите только цифры`,
      },
    },
    agentDocDate: {
      key: "agentDocDate",
      label: "Дата выдачи",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
          return "Дата не может быть ранее 26.09.1996";
        } else {
          return true;
        }
      },
    },
    agentDocDepartment: {
      key: "agentDocDepartment",
      label: "Кем выдан",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentPersNum: {
      key: "agentPersNum",
      label: "Идентификационный номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/,
        message: `Введите номер в формате "0000000A000AA0"`,
      },
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      upperCase: true,
    },
    agentCountry: {
      key: "agentCountry",
      label: "Страна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: true,
      required: false,
      needInForm: true,
      defaultValue: "РЕСПУБЛИКА БЕЛАРУСЬ",
    },
    agentOblId: {
      key: "agentOblId",
      label: "Область или г.Минск",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentRayonId: {
      key: "agentRayonId",
      label: "Район",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentGorodId: {
      key: "agentGorodId",
      label: "Населённый пункт",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: true,
      required: false,
      needInForm: true,
      options: [],
    },
    agentUlica: {
      key: "agentUlica",
      label: "Улица",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[а-яА-ЯёЁ0-9\s.,;:!?-]*$/,
        message: `Заполнение на русском языке, можно использовать цифры и пробелы`,
      },
      upperCase: true,
    },
    agentDom: {
      key: "agentDom",
      label: "Дом",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[^0].*$/,
        message: "Номер дома не может быть 0 или начинаться с 0",
      },
      upperCase: true,
    },
    agentKorpus: {
      key: "agentKorpus",
      label: "Корпус",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentKv: {
      key: "agentKv",
      label: "Квартира",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      upperCase: true,
    },
    agentPhone: {
      key: "agentPhone",
      label: "Телефон",
      type: "text",
      placeholder: "+375 (29) ___-__-__",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9+\s,;()-]*$/,
        message: `Недопустимые символы: введите цифры, (), -, +`,
      },
    },
    agentDoverennost: {
      key: "agentDoverennost",
      label: "Сведения о доверенности",
      type: "text",
      textarea: true,
      rows: 3,
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
  },
};

export const boatInfo = {
  caption: "Сведения о маломерном судне",
  gridKey: "grid-container-boat-info",
  blockVisibility: true,
  inputsOptions: {
    boatVin: {
      key: "boatVin",
      label: "Заводской (идентификационный) номер",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      maxLength: 15,
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      // buttonDisabled: true,
    },
    parkingPlace: {
      key: "parkingPlace",
      label: "Место стоянки",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
    boatType: {
      key: "boatType",
      label: "Тип",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    boatVid: {
      key: "boatVid",
      label: "Вид",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    bodyMaterial: {
      key: "bodyMaterial",
      label: "Материал корпуса",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
    boatPayload: {
      key: "boatPayload",
      label: "Грузоподъемность (кг)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      // max: 225,
      pattern: {
        value: /^\d+(\.|\,)?\d*$/,
        message: `Для ввода доступны только цифры, точка и запятая`,
      },
    },
    engpwrmaxkwt: {
      key: "engpwrmaxkwt",
      label: "Предельная мощность двигателей, кВт",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^\d+(\.|\,)?\d*$/,
        message: "Для ввода доступны только цифры, точка и запятая",
      },
      dotAutoCorrect: true,
    },
    engpwrmax: {
      key: "engpwrmax",
      label: "Предельная мощность\nдвигателей, л.с.",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^\d+(\.|\,)?\d*$/,
        message: "Для ввода доступны только цифры, точка и запятая",
      },
      dotAutoCorrect: true,
    },
    boatYear: {
      key: "boatYear",
      label: "Год постройки",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customValidation(value) {
        if (Number(value)) {
          if (value > new Date().getFullYear()) {
            return "Год не может быть позднее текущего";
          } else {
            return true;
          }
        }
      },
    },
    engineNum: {
      key: "engineNum",
      label: "Количество двигателей",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    boatName: {
      key: "boatName",
      label: "Название (при наличии)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    boatLength: {
      key: "boatLength",
      label: "Длина (м)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      max: 20,
    },
    boatWidth: {
      key: "boatWidth",
      label: "Ширина (м)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
    boatHeight: {
      key: "boatHeight",
      label: "Высота (м)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
    passengersNum: {
      key: "passengersNum",
      label: "Пассажировместимость (чел.)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      max: 12,
    },
    saCategory: {
      key: "saCategory",
      label: "Категория сложности района плавания",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: true,
      required: true,
      needInForm: true,
      options: [],
    },
  },
};

export const enginesTableOptions = {
  keyTable: "boatCardAppEngDtoList",
  caption: "Сведения о двигателе маломерного судна (при его наличии)",
  columnsOptions: {
    engname: {
      label: "Название",
      key: "engname",
      type: "text",
      neededInModal: true,
    },
    engvin: {
      label: "Заводской (идентификационный) номер",
      key: "engvin",
      type: "text",
      neededInModal: true,
    },
    engtype: {
      label: "Тип двигателя",
      key: "engtype",
      type: "selectWithSearch",
      options: [{ value: "", label: "", key: "engtype" }],
      neededInModal: true,
    },
    engpwr: {
      label: "Мощность, л.с.",
      key: "engpwr",
      type: "text",
      neededInModal: true,
    },
    engProdYear: {
      label: "Год выпуска",
      key: "engProdYear",
      type: "text",
      neededInModal: true,
    },
  },
};

export const boatCardAppEngStaticDtoList = {
  keyTable: "boatCardAppEngStaticDtoList",
  caption: "Сведения о стационарных двигателях маломерного судна",
  needInForm: false,
  required: false,
  nameColumn: {
    engnum: {
      value: "Заводской (идентификационный) номер",
      key: "engnum",
      type: "text",
      placeholder: "Выберите",
      required: true,
      neededInModal: true,
    },
    engpwr: {
      value: "Мощность, л.с.",
      key: "engpwr",
      type: "text",
      placeholder: "Выберите",
      required: true,
      neededInModal: true,
    },
  },
};
export const boatCardAppEngDtoList = {
  keyTable: "boatCardAppEngDtoList",
  caption: "Сведения о подвесных двигателях маломерного судна",
  needInForm: false,
  required: false,
  nameColumn: {
    engname: {
      value: "Название",
      key: "engname",
      type: "text",
      placeholder: "Выберите",
      required: true,
      neededInModal: true,
    },
    engvin: {
      value: "Заводской (идентификационный) номер",
      key: "engvin",
      type: "text",
      placeholder: "Выберите",
      required: true,
      neededInModal: true,
    },
    engtype: {
      value: "Тип двигателя",
      key: "engtype",
      placeholder: "Выберите",
      type: "customSelect",
      required: true,
      selectOptions: [],
      neededInModal: true,
    },
    engpwr: {
      value: "Мощность, л.с.",
      key: "engpwr",
      type: "text",
      placeholder: "Выберите",
      required: true,
      neededInModal: true,
    },
    engProdYear: {
      value: "Год выпуска",
      key: "engProdYear",
      type: "text",
      placeholder: "Выберите",
      required: true,
      neededInModal: true,
    },
  },
};
export const boatCardAppDealsDtoList = {
  keyTable: "boatCardAppDealsDtoList",
  caption: "Сведения о правах собственности",
  needInForm: true,
  required: true,
  nameColumn: {
    docNum: {
      value: "Номер документа",
      key: "docNum",
      type: "text",
      neededInModal: true,
      required: true,
    },
    docDate: {
      value: "Дата документа",
      key: "docDate",
      type: "date",
      neededInModal: true,
      required: true,
    },
    docName: {
      value: "Наименование документа",
      key: "docName",
      type: "text",
      neededInModal: true,
      required: true,
    },
    note: {
      value: "Примечание",
      key: "note",
      type: "text",
      neededInModal: true,
      required: false,
    },
  },
};
export const boatCardAppSmDtoList = {
  keyTable: "boatCardAppSmDtoList",
  caption: "Особые отметки",
  needInForm: true,
  required: false,
  nameColumn: {
    asmLock: {
      value: "Ограничение на рег. действия",
      key: "asmLock",
      type: "checkbox",
      neededInModal: true,
      required: true,
    },
    asmDate: {
      value: "Дата",
      key: "asmDate",
      type: "date",
      neededInModal: true,
      required: true,
    },
    asmNote: {
      value: "Отметка",
      key: "asmNote",
      type: "text",
      neededInModal: true,
      required: true,
    },
  },
};

export const isNeedToPaySelector = {
  key: "isNeedToPaySelector",
  label: "Выставить счет на оплату",
  type: "selectWithSearch",
  placeholder: "Выберите",
  fieldModeView: false,
  disabled: false,
  isSearchable: false,
  required: true,
  needInForm: true,
  options: [
    {
      value: true,
      label: "Да",
      key: "isNeedToPaySelector",
    },
    {
      value: false,
      label: "Нет",
      key: "isNeedToPaySelector",
    },
  ],
};

export const optionsForPasswordModal = {
  caption: "Пароль ЭЦП",
  gridKey: "",
  blockVisibility: true,
  inputsOptions: {
    pw: {
      key: "pw",
      label: "Пароль",
      type: "password",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
  },
};

export function setOptionsEngType(prop) {
  const validLib = prop.map((el) => {
    return { ...el, key: "engtype" };
  });
  if (boatCardAppEngDtoList.nameColumn.engtype.selectOptions.length === 0) {
    boatCardAppEngDtoList.nameColumn.engtype.selectOptions.push(...validLib);
  }
}

export async function setOptionsInterestedPerson(value, key, type) {
  if (type === 1) {
    switch (key) {
      case "oblId": {
        if (Number(value[key]) === 5) {
          interestedIndividual.inputsOptions.rayonId.options = [];
          interestedIndividual.inputsOptions.rayonId.disabled = true;
          interestedIndividual.inputsOptions.rayonId.required = false;
          interestedIndividual.inputsOptions.gorodId.options = [];
          interestedIndividual.inputsOptions.gorodId.disabled = true;
          interestedIndividual.inputsOptions.gorodId.required = false;
          return interestedIndividual;
        } else {
          const rayons = await getRayon(value[key]);
          const cities = await getCityByObl(value[key]);
          const rayonsValid =
            rayons?.map((item) => {
              item.key = "rayonId";
              return item;
            }) || [];
          interestedIndividual.inputsOptions.rayonId.options = rayonsValid;
          interestedIndividual.inputsOptions.rayonId.disabled = interestedIndividual.inputsOptions.rayonId
            .options.length
            ? false
            : true;
          interestedIndividual.inputsOptions.rayonId.required = true;
          interestedIndividual.inputsOptions.gorodId.options = cities;
          interestedIndividual.inputsOptions.gorodId.disabled = false;
          interestedIndividual.inputsOptions.gorodId.required = true;

          return interestedIndividual;
        }
      }
      case "rayonId": {
        if (!value.gorodId) {
          const gorod = await getGorod(value[key]);
          const gorodValid =
            gorod?.map((item) => {
              item.key = "gorodId";
              return item;
            }) || [];
          interestedIndividual.inputsOptions.gorodId.options = gorodValid;
          interestedIndividual.inputsOptions.gorodId.disabled = interestedIndividual.inputsOptions.gorodId
            .options.length
            ? false
            : true;
        }
        return interestedIndividual;
      }
      case "gorodId": {
        const selectedOptions = interestedIndividual.inputsOptions.gorodId.options.find(
          (item) => value[key] === item.value,
        );
        if (selectedOptions.label.includes("г.")) {
          interestedIndividual.inputsOptions.rayonId.required = false;
        } else {
          interestedIndividual.inputsOptions.rayonId.required = true;
        }

        const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

        if (request.ok) {
          const response = await request.json();
          const rayonsValid =
            response?.map((item) => {
              return {
                value: item.id,
                label: item.name,
                key: "rayonId",
              };
            }) || [];
          interestedIndividual.inputsOptions.rayonId.options = rayonsValid;
          interestedIndividual.inputsOptions.rayonId.disabled = interestedIndividual.inputsOptions.rayonId
            .options.length
            ? false
            : true;
        }
        return interestedIndividual;
      }
      default:
        return interestedIndividual;
    }
  } else {
    switch (key) {
      case "oblId": {
        if (Number(value[key]) === 5) {
          interestedEntity.inputsOptions.rayonId.options = [];
          interestedEntity.inputsOptions.rayonId.disabled = true;
          interestedEntity.inputsOptions.rayonId.required = false;
          interestedEntity.inputsOptions.gorodId.options = [];
          interestedEntity.inputsOptions.gorodId.disabled = true;
          interestedEntity.inputsOptions.gorodId.required = false;
          return interestedEntity;
        } else {
          const rayons = await getRayon(value[key]);
          const cities = await getCityByObl(value[key]);
          const rayonsValid =
            rayons?.map((item) => {
              item.key = "rayonId";
              return item;
            }) || [];
          interestedEntity.inputsOptions.rayonId.options = rayonsValid;
          interestedEntity.inputsOptions.rayonId.disabled = interestedEntity.inputsOptions.rayonId.options
            .length
            ? false
            : true;
          interestedEntity.inputsOptions.rayonId.required = true;
          interestedEntity.inputsOptions.gorodId.options = cities;
          interestedEntity.inputsOptions.gorodId.disabled = false;
          interestedEntity.inputsOptions.gorodId.required = true;

          return interestedEntity;
        }
      }
      case "rayonId": {
        if (!value.gorodId) {
          const gorod = await getGorod(value[key]);
          const gorodValid =
            gorod?.map((item) => {
              item.key = "gorodId";
              return item;
            }) || [];
          interestedEntity.inputsOptions.gorodId.options = gorodValid;
          interestedEntity.inputsOptions.gorodId.disabled = interestedEntity.inputsOptions.gorodId.options
            .length
            ? false
            : true;
        }
        return interestedEntity;
      }
      case "gorodId": {
        const selectedOptions = interestedEntity.inputsOptions.gorodId.options.find(
          (item) => value[key] === item.value,
        );
        if (selectedOptions.label.includes("г.")) {
          interestedEntity.inputsOptions.rayonId.required = false;
        } else {
          interestedEntity.inputsOptions.rayonId.required = true;
        }
        const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

        if (request.ok) {
          const response = await request.json();
          const rayonsValid =
            response?.map((item) => {
              return {
                value: item.id,
                label: item.name,
                key: "rayonId",
              };
            }) || [];
          interestedEntity.inputsOptions.rayonId.options = rayonsValid;
          interestedEntity.inputsOptions.rayonId.disabled = interestedEntity.inputsOptions.rayonId.options
            .length
            ? false
            : true;
        }
        return interestedEntity;
      }
      default:
        return interestedEntity;
    }
  }
}

export async function setOptionsRepresentPerson(value, key, type) {
  switch (key) {
    case "agentOblId": {
      if (Number(value[key]) === 5) {
        representPerson.inputsOptions.agentRayonId.options = [];
        representPerson.inputsOptions.agentRayonId.disabled = true;
        representPerson.inputsOptions.agentGorodId.options = [];
        representPerson.inputsOptions.agentGorodId.disabled = true;

        representPerson.inputsOptions.agentRayonId.required = false;
        representPerson.inputsOptions.agentGorodId.required = false;

        return representPerson;
      } else {
        const rayons = await getRayon(value[key]);
        const rayonsValid =
          rayons?.map((item) => {
            item.key = "agentRayonId";
            return item;
          }) || [];
        const cities = await getCityByObl(value[key]);
        const citiesValid =
          cities?.map((item) => {
            item.key = "agentGorodId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentRayonId.options = rayonsValid;
        representPerson.inputsOptions.agentRayonId.disabled = representPerson.inputsOptions.agentRayonId
          .options.length
          ? false
          : true;
        representPerson.inputsOptions.agentGorodId.options = citiesValid;
        representPerson.inputsOptions.agentGorodId.disabled = false;
        if (type === 2) {
          representPerson.inputsOptions.agentRayonId.required = true;
          representPerson.inputsOptions.agentGorodId.required = true;
        }
        return representPerson;
      }
    }
    case "agentRayonId": {
      if (!value.agentGorodId) {
        const gorod = await getGorod(value[key]);
        const gorodValid =
          gorod?.map((item) => {
            item.key = "agentGorodId";
            return item;
          }) || [];
        representPerson.inputsOptions.agentGorodId.options = gorodValid;
        representPerson.inputsOptions.agentGorodId.disabled = representPerson.inputsOptions.agentGorodId
          .options.length
          ? false
          : true;
      }
      return representPerson;
    }
    case "agentGorodId": {
      const selectedOptions = representPerson.inputsOptions.agentGorodId.options.find(
        (item) => value[key] === item.value,
      );

      if (type === 2) {
        if (selectedOptions.label.includes("г.")) {
          representPerson.inputsOptions.agentRayonId.required = false;
        } else {
          representPerson.inputsOptions.agentRayonId.required = true;
        }
      }

      const request = await fetchWithToken(MAIN_URL + PORT + API_GET_RAYONS_BY_GOROD_ID + value[key]);

      if (request.ok) {
        const response = await request.json();
        const rayonsValid =
          response?.map((item) => {
            return {
              value: item.id,
              label: item.name,
              key: "agentRayonId",
            };
          }) || [];
        representPerson.inputsOptions.agentRayonId.options = rayonsValid;
        representPerson.inputsOptions.agentRayonId.disabled = representPerson.inputsOptions.agentRayonId
          .options.length
          ? false
          : true;
      }
      return representPerson;
    }
    default:
      return representPerson;
  }
}

export function setDocOptionsDocumentsFromDictionariesInterested(docLib) {
  if (docLib.length > 0) {
    const validLibInterested = docLib.map((item) => {
      return {
        ...item,
        key: "docType",
      };
    });
    if (interestedIndividual.inputsOptions.docType.options.length === 0) {
      interestedIndividual.inputsOptions.docType.options.push(...validLibInterested);
    }
    // return interestedIndividual;
  }
}

export function setDocOptionsDocumentsFromDictionariesRepresent(docLib) {
  if (docLib.length > 0) {
    const validLibRepresent = docLib.map((item) => {
      return {
        ...item,
        key: "agentDocType",
      };
    });
    if (representPerson.inputsOptions.agentDocType.options.length === 0) {
      representPerson.inputsOptions.agentDocType.options.push(...validLibRepresent);
    }
    // return representPerson;
  }
}

export function setOblOptionsFromDictionariesInterested(oblLib, type) {
  const validLibInterested = oblLib.map((item) => {
    return {
      ...item,
      key: "oblId",
    };
  });

  if (interestedIndividual.inputsOptions.oblId.options.length === 0) {
    interestedIndividual.inputsOptions.oblId.options.push(...validLibInterested);
  }
  if (interestedEntity.inputsOptions.oblId.options.length === 0) {
    interestedEntity.inputsOptions.oblId.options.push(...validLibInterested);
  }
  // return interestedIndividual;
  // type === 1 ? interestedIndividual : interestedEntity;
}

export function setOblOptionsFromDictionariesRepresent(oblLib) {
  const validLibRepresent = oblLib.map((item) => {
    return {
      ...item,
      key: "agentOblId",
    };
    // key: "agentOblastId",
  });
  if (representPerson.inputsOptions.agentOblId.options.length === 0) {
    representPerson.inputsOptions.agentOblId.options.push(...validLibRepresent);
  }
  // return representPerson;
}

export function setOptionsForBoat(types, kinds, materials, saCategory) {
  const validTypes = types.map((item) => {
    return { ...item, key: "boatType" };
  });
  const validKinds = kinds.map((item) => {
    return { ...item, key: "boatVid" };
  });
  const validMaterials = materials.map((item) => {
    return { ...item, key: "bodyMaterial" };
  });
  const validCategory = saCategory.map((item) => {
    return { ...item, key: "saCategory" };
  });
  if (boatInfo.inputsOptions.boatType.options.length === 0) {
    boatInfo.inputsOptions.boatType.options.push(...validTypes);
  }
  if (boatInfo.inputsOptions.boatVid.options.length === 0) {
    boatInfo.inputsOptions.boatVid.options.push(...validKinds);
  }
  if (boatInfo.inputsOptions.bodyMaterial.options.length === 0) {
    boatInfo.inputsOptions.bodyMaterial.options.push(...validMaterials);
  }
  if (boatInfo.inputsOptions.saCategory.options.length === 0) {
    boatInfo.inputsOptions.saCategory.options.push(...validCategory);
  }
  // return boatInfo;
}

export function setGridsByMode(mode, typeId) {
  if (typeId) {
    if (mode === "add") {
      representPerson.gridKey = "grid-container-represent";
      representPerson.inputsOptions.addressCaption.needInForm = false;
      representPerson.inputsOptions.personalDataCaption.needInForm = false;
      if (typeId === 2) {
        for (let item in representPerson.inputsOptions) {
          if (item !== "agentUlica" && item !== "agentKorpus" && item !== "agentKv") {
            representPerson.inputsOptions[item].required = true;
          }
        }
      } else {
        for (let item in representPerson.inputsOptions) {
          representPerson.inputsOptions[item].required = false;
        }
      }
    } else {
      interestedIndividual.gridKey = "grid-container-individual-view";
      interestedIndividual.inputsOptions.personalDataCaption.needInForm = true;
      interestedIndividual.inputsOptions.addressCaption.needInForm = true;
      interestedEntity.gridKey = "grid-container-entity-view";
      interestedEntity.inputsOptions.personalDataCaption.needInForm = true;
      interestedEntity.inputsOptions.addressCaption.needInForm = true;
      representPerson.gridKey = "grid-container-represent-view";
      representPerson.inputsOptions.personalDataCaption.needInForm = true;
      representPerson.inputsOptions.addressCaption.needInForm = true;
      boatInfo.gridKey = "grid-container-boat-info-view";
      boatInfo.inputsOptions.engpwrmaxkwt.needInForm = false;
    }
    return {
      interested: typeId === 1 ? interestedIndividual : interestedEntity,
      represent: representPerson,
      boatInfo: boatInfo,
    };
  }
}

export function clearOptions() {
  interestedIndividual.gridKey = "grid-container-individual";
  interestedEntity.gridKey = "grid-container-entity";
  representPerson.gridKey = "grid-container-represent";
  boatInfo.gridKey = "grid-container-boat-info";

  interestedIndividual.inputsOptions.rayonId.options = [];
  interestedIndividual.inputsOptions.rayonId.disabled = true;
  interestedIndividual.inputsOptions.gorodId.options = [];
  interestedIndividual.inputsOptions.gorodId.disabled = true;
  interestedIndividual.inputsOptions.personalDataCaption.needInForm = false;
  interestedIndividual.inputsOptions.addressCaption.needInForm = false;
  interestedEntity.inputsOptions.rayonId.options = [];
  interestedEntity.inputsOptions.rayonId.disabled = true;
  interestedEntity.inputsOptions.gorodId.options = [];
  interestedEntity.inputsOptions.gorodId.disabled = true;
  interestedEntity.inputsOptions.personalDataCaption.needInForm = false;
  interestedEntity.inputsOptions.addressCaption.needInForm = false;
  representPerson.inputsOptions.agentRayonId.options = [];
  representPerson.inputsOptions.agentRayonId.disabled = true;
  representPerson.inputsOptions.agentGorodId.options = [];
  representPerson.inputsOptions.agentGorodId.disabled = true;
  boatInfo.inputsOptions.engpwrmaxkwt.needInForm = true;
  boatInfo.inputsOptions.boatType.options = [];
  boatInfo.inputsOptions.boatVid.options = [];
  boatInfo.inputsOptions.bodyMaterial.options = [];
  boatInfo.inputsOptions.saCategory.options = [];
}

export function setDefaultOptionsRepresent(mode, visibilityKey, countryKey) {
  if (mode === "add") {
    representPerson.inputsOptions.agentCountry.defaultValue = "Республика Беларусь";
  } else {
    if (visibilityKey) {
      if (countryKey) {
        representPerson.inputsOptions.agentCountry.defaultValue = "Республика Беларусь";
      } else {
        representPerson.inputsOptions.agentCountry.defaultValue = "";
      }
    } else {
      representPerson.blockVisibility = false;
    }
  }
  return representPerson;
}

export function toggleSearchButton(result) {
  if (result) {
    if (interestedEntity.inputsOptions.unp.customButton) {
      interestedEntity.inputsOptions.unp.buttonDisabled = true;
      interestedEntity.inputsOptions.unp.disabled = true;
    }
  } else {
    interestedEntity.inputsOptions.unp.buttonDisabled = true;
  }

  return interestedEntity;
}

export function setDefaultOptions() {
  interestedEntity.inputsOptions.unp.buttonDisabled = false;
  interestedEntity.inputsOptions.unp.disabled = false;
}

export function setButtonVisibilityByAccess(access) {
  interestedEntity.inputsOptions.unp.customButton = access;
  return interestedEntity;
}

export function toggleRequiredEngPowerByEngineNum(value) {
  if (value > 0) {
    boatInfo.inputsOptions.engpwrmaxkwt.required = true;
    boatInfo.inputsOptions.engpwrmax.required = true;
  } else {
    boatInfo.inputsOptions.engpwrmaxkwt.required = false;
    boatInfo.inputsOptions.engpwrmax.required = false;
  }
  return boatInfo;
}

export function toggleRequiredEngPowerByBoatType(value) {
  if (value === 2) {
    boatInfo.inputsOptions.engpwrmaxkwt.required = true;
    boatInfo.inputsOptions.engpwrmax.required = true;
  } else {
    boatInfo.inputsOptions.engpwrmaxkwt.required = false;
    boatInfo.inputsOptions.engpwrmax.required = false;
  }
  return boatInfo;
}

export function toggleDisabledSearchButton(value) {
  if (value) {
    boatInfo.inputsOptions.boatVin.buttonDisabled = true;
  } else {
    boatInfo.inputsOptions.boatVin.buttonDisabled = false;
  }
  return boatInfo;
}

export function setMidnameRequiredByDocType(docType) {
  if (docType === 1 || docType === 4) {
    interestedIndividual.inputsOptions.midname.required = true;
  } else {
    interestedIndividual.inputsOptions.midname.required = false;
  }
  return interestedIndividual;
}

export async function toggleEngDtoListRequired(type, engineNum) {
  if (type) {
    if (type === 2 || type === 6) {
      boatCardAppEngStaticDtoList.required = false;
      boatCardAppEngDtoList.needInForm = true;
      boatCardAppEngDtoList.required = Number(engineNum) > 0;
    } else {
      boatCardAppEngStaticDtoList.required = true;
      boatCardAppEngDtoList.required = false;
      boatCardAppEngDtoList.needInForm = false;
    }
  }

  return {
    boatCardAppEngDtoList: boatCardAppEngDtoList,
    boatCardAppEngStaticDtoList: boatCardAppEngStaticDtoList,
  };
}
